export const CATEGORIE_TO_TRANSFERT = [
  {
    moduleCible: 'presse',
    moduleDestination: 'achat',
    categorieCible: 'marche',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'fournisseur_support',
    moduleDestination: 'achat',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'parution',
    moduleDestination: 'bodac',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'couleur_encart',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'emplacement_presse',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'periodicite',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'surface',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'mode_distribution',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'type_format_presse',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'etat_suivi_administratif',
    moduleDestination: 'parametrage',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'chemin_fer',
    moduleDestination: 'bodac',
  },
  {
    moduleCible: 'presse',
    categorieCible: 'type_evenement_sponsoring',
    moduleDestination: 'bodac',
  },
  {
    moduleCible: 'bodac',
    categorieCible: 'format_affiche',
    moduleDestination: 'parametrage',
  },
];

export const MODULES = [
  {
    name: 'bodac',
    image: '/static/img/Gestion%20commerciale.svg',
    categorie: [
      'devis',
      'commandes',
      'factures',
      'remises_bancaires',
      'catalogue',
      'clients/contacts',
      'relance',
    ],
  },
  {
    name: 'gabed',
    image: '/static/img/Patrimoine.svg',
    categorie: [
      'emplacement',
    ],
  },
  {
    name: 'baux',
    image: '/static/img/Baux.svg',
    categorie: [],
  },
  {
    name: 'logistique',
    image: '/static/img/Logistique.svg',
    categorie: [
      'tournee_modele',
      'afficheur',
      'demande',
      'affectation',
      'type_ot',
      'previsionnel',
    ],
  },
  {
    name: 'presse',
    image: '/static/img/presse.svg',
    categorie: [],
  },
  {
    name: 'comptabilite',
    image: '/static/img/Comptabilite.svg',
    categorie: [
      'journal_ecriture',
      'lots_comptable',
    ],
  },
  {
    name: 'achat',
    image: '/static/img/Achat.svg',
    categorie: [],
  },
  {
    name: 'parametrage',
    image: '/static/img/ecrou.svg',
    categorie: [
      'general',
      'collaborateurs',
      'societe/agence',
      'roles',
      'exercice_comptable',
      'domiciliation_bancaire',
      'mode_reglement',
      'schema_comptable',
      'exercice_comptable',
    ],
  },
  {
    name: 'stock',
    image: '/static/img/Stock.svg',
    categorie: [],
  },
];

export const DROITS = [
  'lecture',
  'maj',
  'supprimer',
  'exporter',
  'edition',
];
